import React from 'react'
import { Controller } from 'react-hook-form'
import { WEEKDAYS } from '@/utilities'
import { ControlledCheckbox, LayoutColumn, Label } from '../../common'
import { Box, Icon, Radio, RadioGroup } from '@maui/elements'

export const DailyPreferences = React.memo(({ error, control, register }) => {
  return (
    <LayoutColumn gap='spaceGapSmall'>
      <Label htmlFor='deliveryDays'>
        Daily Delivery Preferences
      </Label>
      {
        error &&
        <Box color="colorFeedbackError" fontStyle="italic" display="flex" flexDirection="row" alignItems="center" gap="spaceGapSmall">
          <Icon name="alert-circle" />
          Please make a selection
        </Box>
      }
      <Box display="flex" flexDirection="row" gap="spaceGapXLarge" alignItems="center" pl="spacePaddingMedium" py="spacePaddingSmall">
        {
          WEEKDAYS.map(({ label, value }, index) => {
            return (
              <ControlledCheckbox
                key={index}
                name="deliveryDays"
                control={control}
                label={label}
                register={register}
                required={true}
                value={value}
              />
            )
          })
        }
      </Box>
    </LayoutColumn>
  )
})

DailyPreferences.displayName = 'DailyPreferences'

const HourlyPreferences = () => {
  return (
    <LayoutColumn gap='spaceGapSmall' pl="spacePaddingMedium">
      You will receive a digest delivery email every hour
    </LayoutColumn>
  )
}

HourlyPreferences.displayName = 'HourlyPreferences'

export const Frequency = ({
  control,
  errors,
  clearErrors,
  frequency,
  setFrequency,
  register,
  setValue,
  threatProfileDigest,
}) => {
  return (
    <>
      {!threatProfileDigest && <>
        <LayoutColumn gap='spaceGapSmall'>
          <Label htmlFor='deliveryFreq'>
            Frequency
          </Label>
          <Controller
            control={control}
            name='deliveryFreq'
            render={({
              field: { onChange, value, ref },
            }) => (
              <RadioGroup
                onChange={(e) => {
                  onChange(e)
                  setFrequency(e.target.value)
                  clearErrors('deliveryDays')
                  setValue('deliveryDays', '')
                }}
                value={value}
                ref={ref}
                display="flex"
                gap="spaceGapXLarge"
              >
                <Radio value="DAILY">
                  Daily
                </Radio>
                <Radio value="HOURLY">
                  Hourly
                </Radio>
              </RadioGroup>
            )}
          />
        </LayoutColumn>
      </>
      }
      {frequency === 'DAILY' && <DailyPreferences error={errors?.deliveryDays} control={control} register={register} setValue={setValue} />}
      {frequency === 'HOURLY' && <HourlyPreferences />}
    </>
  )
}
